import React from 'react';
import { Box, Button, Flex, IconButton, Input, Text } from '@chakra-ui/react';
import { Plus, Trash } from 'phosphor-react';
import { IItemEscopo } from '../../../../hooks/useEventoContrato';
import { brl, somaDoEscopo } from './dinheiro';

interface Props {
  itens: IItemEscopo[];
  valorTotal?: string | null;
  bloqueado: boolean;
  onChange: (itens: IItemEscopo[]) => void;
}

/**
 * Os itens do escopo, que viram a TABELA no lugar da imagem do Anexo.
 *
 * No template, o escopo do fornecedor anterior é um print de tabela — o motor
 * não troca imagem por texto, então a imagem sai e entra uma tabela montada
 * com estes itens (como o jurídico fazia no Claude web). Sem itens, a imagem
 * do anterior fica no documento e o gate barra.
 */
export default function TabelaEscopo({ itens, valorTotal, bloqueado, onChange }: Props) {
  const mudar = (i: number, campo: keyof IItemEscopo, valor: string) =>
    onChange(itens.map((it, j) => (j === i ? { ...it, [campo]: valor } : it)));
  const { soma, total, bate } = somaDoEscopo(itens, valorTotal);

  return (
    <Box>
      <Flex gap={2} mb={1} px={1} fontSize="11px" color="gray.500" fontWeight={600}>
        <Text flex={3}>SERVIÇO</Text>
        <Text flex={1}>QUANTIDADE</Text>
        <Text flex={1.2}>VALOR</Text>
        <Box w="32px" />
      </Flex>
      {itens.map((it, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Flex key={i} gap={2} mb={2} align="center">
          <Input
            size="sm"
            flex={3}
            placeholder="Serviço"
            value={it.descricao}
            isDisabled={bloqueado}
            onChange={e => mudar(i, 'descricao', e.target.value)}
          />
          <Input
            size="sm"
            flex={1}
            placeholder="—"
            value={it.quantidade ?? ''}
            isDisabled={bloqueado}
            onChange={e => mudar(i, 'quantidade', e.target.value)}
          />
          <Input
            size="sm"
            flex={1.2}
            placeholder="—"
            value={it.valor ?? ''}
            isDisabled={bloqueado}
            onChange={e => mudar(i, 'valor', e.target.value)}
          />
          <IconButton
            aria-label="Tirar item"
            icon={<Trash size={14} />}
            size="sm"
            variant="ghost"
            colorScheme="red"
            isDisabled={bloqueado}
            onClick={() => onChange(itens.filter((_, j) => j !== i))}
          />
        </Flex>
      ))}
      <Flex align="center" justify="space-between" mt={2} gap={3} flexWrap="wrap">
        <Button
          size="xs"
          variant="outline"
          leftIcon={<Plus size={12} />}
          isDisabled={bloqueado}
          onClick={() => onChange([...itens, { descricao: '', quantidade: '', valor: '' }])}
        >
          Adicionar item
        </Button>
        {itens.length > 0 && (
          <Text fontSize="12px" color={total === null || bate ? 'gray.600' : 'orange.600'}>
            Soma dos itens: <b>{brl(soma)}</b>
            {total !== null &&
              (bate ? ' — bate com o valor total ✓' : ` — o valor total é ${brl(total)}`)}
          </Text>
        )}
      </Flex>
    </Box>
  );
}
